import { sprinkles } from '@design-system/sprinkles.css';
import { Typography } from '../typography/typography';
import {
  circleProgressSvg,
  progressGuideValue,
  progressGuideWrapper,
  progressGuideValueText,
  progressGuideValueSvg,
} from './navMenu.css';
import { useBreakpoints } from '@design-system/breakpointsStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle as faCheckCircleDuotone } from '@fortawesome/pro-duotone-svg-icons';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import { pickObject } from '@client/new/helpers/general';
import { useShallow } from 'zustand/react/shallow';

export type PorgressGuideProps = {
  progress: number;
};

export const PorgressGuide = (p: PorgressGuideProps) => {
  const { tablet, mobile } = useBreakpoints(
    useShallow((s) => pickObject(s, ['tablet', 'mobile'])),
  );

  const progress = Math.min(Math.max(p.progress, 0), 100);
  const isCompleted = progress === 100;
  const circleWidth = tablet ? 20 : 44;

  return (
    <div className={progressGuideWrapper}>
      <CircularProgress
        strokeWidth={6}
        size={circleWidth}
        progress={progress}
      />
      <div className={progressGuideValue}>
        {isCompleted ? (
          tablet ? (
            <FontAwesomeIcon
              className={progressGuideValueSvg}
              icon={faCheckCircleDuotone}
              style={assignInlineVars({
                '--fa-secondary-color': 'N-100',
                '--fa-secondary-opacity': '1',
              })}
            />
          ) : (
            <FontAwesomeIcon
              className={progressGuideValueSvg}
              icon={faCheckCircle}
            />
          )
        ) : tablet ? null : (
          <Typography
            variant="body"
            size="small"
            color="W-100"
            className={progressGuideValueText}
          >
            {progress}%
          </Typography>
        )}
      </div>
      {mobile && (
        <Typography variant="body" size="large" color="W-100">
          Set up guide
        </Typography>
      )}
    </div>
  );
};

type ProgressProps = {
  size: number;
  strokeWidth: number;
  progress: number;
};

const CircularProgress = ({ size, strokeWidth, progress }: ProgressProps) => {
  const viewBox = `0 0 ${size} ${size}`;
  const radius = (size - strokeWidth) / 2;

  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      className={circleProgressSvg}
    >
      <circle
        fill="none"
        stroke="currentColor"
        className={sprinkles({ color: 'N-80' })}
        cx={size / 2}
        cy={size / 2}
        r={radius}
        strokeWidth={`${strokeWidth}px`}
      />

      <circle
        fill="none"
        stroke="currentColor"
        className={sprinkles({ color: 'SUCCESS-100' })}
        cx={size / 2}
        cy={size / 2}
        r={radius}
        strokeWidth={`${strokeWidth}px`}
        strokeDasharray={
          (progress / 100) * Math.PI * radius * 2 + ' ' + Math.PI * radius * 2
        }
      />
    </svg>
  );
};
